module.exports = __webpack_public_path__ + "static/img/pop_ico02.ca22a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pop_ico02.png
// module id = 3rAP
// module chunks = 1